import { Component } from '@angular/core';
import { CoreIcon, ICON_TEMPLATE } from '@primeicons/angular/core';
import { chevronLeft } from '@primeicons/core/chevron-left';

@Component({
    selector: 'svg[data-p-icon="chevron-left"]',
    standalone: true,
    template: ICON_TEMPLATE
})
export class ChevronLeft extends CoreIcon {
    constructor() {
        super();
        this._icon = chevronLeft;
    }
}
